import { useEffect, useRef } from "react";

// Lightweight Leaflet map (loaded via CDN in index.html as window.L)
export default function MapView({ hotel, markers = [], accent = "#C5A880", height = 220 }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    const L = window.L;
    if (!L || !ref.current) return;
    const pts = [];
    if (hotel?.lat != null && hotel?.lng != null) pts.push([hotel.lat, hotel.lng]);
    markers.forEach((m) => { if (m.lat != null && m.lng != null) pts.push([m.lat, m.lng]); });
    if (pts.length === 0) return;

    if (!mapRef.current) {
      mapRef.current = L.map(ref.current, { scrollWheelZoom: false, attributionControl: false });
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(mapRef.current);
    }
    const map = mapRef.current;
    map.eachLayer((l) => { if (l instanceof L.Marker) map.removeLayer(l); });

    const dot = (color) => L.divIcon({ className: "", html: `<div style="background:${color};width:16px;height:16px;border-radius:50%;border:3px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4)"></div>`, iconSize: [16, 16], iconAnchor: [8, 8] });
    if (hotel?.lat != null && hotel?.lng != null) L.marker([hotel.lat, hotel.lng], { icon: dot("#0A0D10") }).addTo(map).bindPopup(`<b>${hotel.name || "Us"}</b>`);
    markers.forEach((m) => { if (m.lat != null && m.lng != null) L.marker([m.lat, m.lng], { icon: dot(accent) }).addTo(map).bindPopup(`<b>${m.title || ""}</b>${m.distance ? "<br/>" + m.distance : ""}`); });

    const bounds = L.latLngBounds(pts);
    map.fitBounds(bounds.pad(0.3), { maxZoom: 15 });
    setTimeout(() => map.invalidateSize(), 200);
  }, [hotel, markers, accent]);

  const hasPts = (hotel?.lat != null) || markers.some((m) => m.lat != null);
  if (!hasPts) return null;
  return <div ref={ref} data-testid="map-view" style={{ height, width: "100%", borderRadius: 8, overflow: "hidden", zIndex: 0 }} className="border border-border" />;
}
